import { render, staticRenderFns } from "./resetPasswordExpired.vue?vue&type=template&id=767788a7&"
import script from "./resetPasswordExpired.vue?vue&type=script&lang=ts&"
export * from "./resetPasswordExpired.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports